export default "__VITE_ASSET__jneNExVg__"